import { FunctionComponent } from 'react';
import { Card } from 'react-bootstrap';
import cn from 'classnames';
import styles from './ProAccountsCard.module.css';
import skeletonStyles from './ProAccountsCardSkeleton.module.css';

const ProAccountsCardSkeleton: FunctionComponent<{ className?: string }> = ({ className }) => {
    return (
        <Card bsPrefix={cn(styles.proAccountsCard, className)}>
            <Card.Header as={'div'} bsPrefix={styles.cardDataHeader}>
                <div className={cn('shimmer-bg', skeletonStyles.skeletonTitle)}></div>
                <div className={cn('shimmer-bg', skeletonStyles.skeletonValue)}></div>
            </Card.Header>
            <Card.Footer as={'div'} bsPrefix={cn(styles.cardDataFooter, skeletonStyles.skeletonFooter)}>
                <div className={cn('shimmer-bg', skeletonStyles.skeletonFooterText)}></div>
            </Card.Footer>
        </Card>
    );
};

export default ProAccountsCardSkeleton;
